<template id="Succession">
<Modele id="Succession"/>
</template>

<script>
import Modele from '../Modele.vue'
export default {
	components:{Modele},
	name: 'Succession',
	data () {
		return {}
	}
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Immatriculation/Succession.vue